const chargeback = `[This email has been auto-generated]

Please find attached a CSV containing the cost of each report generated recently through the Avail platform by your fee earners. Even though your firm pays for the Avail platform on a monthly basis, the firm has chosen to bill these back to individual client/matters and has requested this CSV to allow them to do so.

Please be aware that there is no specific invoice to accompany this CSV, and that these costs will be covered by the monthly subscription fee for the platform.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,
Avail
`;

const disbursements = `[This email has been auto-generated]

Please find attached a CSV file named ‘Disbursements CSV [Date].csv’ containing the disbursements ordered by your fee earners through the Avail platform recently.

Please note that some items are subject to VAT, and some are not. The CSV file shows the net cost excluding VAT for all disbursements.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,
Avail
`;

const xero = `[This email has been auto-generated]

Please find attached a PDF file named ‘Disbursements Invoice [Date].pdf’ containing the disbursements ordered by your fee earners through the Avail platform recently. The CSV file(s) containing these disbursements have previously been sent.

Please note that some items are subject to VAT, and some are not. The VAT has been applied as applicable in the invoice.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,
Avail
`;

const disbursementsChargeback = `[This email has been auto-generated]

Please find attached:

(a)\tA CSV file named ‘Disbursements CSV [Date].csv’ containing the disbursements ordered by your fee earners through the Avail platform recently.

Please note that some items are subject to VAT, and some are not. The CSV file shows the net cost excluding VAT for all disbursements.

(b)\tA CSV file named ‘Report Analysis Costs CSV [Date].csv’ containing the cost of each report generated recently through the Avail platform by your fee earners. Even though your firm pays for the Avail platform monthly, the firm has chosen to bill individual reports back to individual client/matters and has requested this CSV to allow them to do so.

Please be aware that there is no invoice to accompany this CSV, and that these costs will be covered by the monthly subscription fee for the platform.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,

Avail AI`;

const monthly = `The Avail monthly report for  {display_name}.

The report was automatically produced on {right_now}.

`;

const leaseMonthly = `The Avail lease monthly report for  {display_name}.

The report was automatically produced on {right_now}.

`;

const leaseDisbursements = `[This email has been auto-generated]

Please find attached a CSV containing the cost of each report generated recently through the Avail platform by your fee earners. Even though your firm pays for the Avail platform on a monthly basis, the firm has chosen to bill these back to individual client/matters and has requested this CSV to allow them to do so.

Please be aware that there is no specific invoice to accompany this CSV, and that these costs will be covered by the monthly invoice for the platform.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,
Avail`;

const leaseDisbursementsXero = `[This email has been auto-generated]

Please find attached:

Please find attached a CSV containing the cost of each report generated recently through the Avail platform by your fee earners. Even though your firm pays for the Avail platform on a monthly basis, the firm has chosen to bill these back to individual client/matters and has requested this CSV to allow them to do so. Additionally, you may find an accompanying PDF invoice titled "Lease Invoice - [Date].pdf", which includes charges for usage exceeding your subscription limit.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,

Avail AI`;

const disbursementsChargebackXero = `[This email has been auto-generated]

Please find attached:

(a)\tA CSV file named ‘Disbursements CSV [Date].csv’ containing the disbursements ordered by your fee earners through the Avail platform recently. This CSV file is accompanied by an invoice PDF named ‘Disbursements Invoice [Date].pdf’ for the same.

Please note that some items are subject to VAT, and some are not. The CSV file shows the net cost excluding VAT for all disbursements, and VAT has been applied as applicable in the invoice.

(b)\tA CSV file named ‘Report Analysis Costs CSV [Date].csv’ containing the cost of each report generated recently through the Avail platform by your fee earners. Even though your firm pays for the Avail platform monthly, the firm has chosen to bill individual reports back to individual client/matters and has requested this CSV to allow them to do so.

Please be aware that there is no invoice to accompany this CSV, and that these costs will be covered by the monthly subscription fee for the platform.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,

Avail AI
`;

const disbursementsXero = `[This email has been auto-generated]

Please find attached a CSV file named 'Disbursements CSV [Date].csv' containing the disbursements ordered by your fee earners through the Avail platform recently. This CSV file is accompanied by an invoice PDF named 'Disbursements Invoice [Date].pdf' for the same.

Please note that some items are subject to VAT, and some are not. The CSV file shows the net cost excluding VAT for all disbursements, and VAT has been applied as applicable in the invoice.

If you have any questions on this, please reach out to finance@avail.ai.

Many thanks,
Avail
`;

export const BodyTplFrequentOptionsKey = {
    disbursementsChargebackXero: 'disbursementsChargebackXero',
    disbursementsChargeback: 'disbursementsChargeback',
    disbursementsXero: 'disbursementsXero',
    disbursements: 'disbursements',
    chargeback: 'chargeback',
    monthly: 'monthly',
    xero: 'xero',
    leaseMonthly: 'leaseMonthly',
    leaseDisbursements: 'leaseDisbursements',
    leaseDisbursementsXero: 'leaseDisbursementsXero',
};

export const bodyTplFrequentOptions = {
    [BodyTplFrequentOptionsKey.disbursementsChargebackXero]: {
        key: BodyTplFrequentOptionsKey.disbursementsChargebackXero,
        displayName: 'Disbursements chargeback xero',
        content: disbursementsChargebackXero,
        color: '#FF5733',
    },
    [BodyTplFrequentOptionsKey.disbursementsChargeback]: {
        key: BodyTplFrequentOptionsKey.disbursementsChargeback,
        displayName: 'Disbursements chargeback',
        content: disbursementsChargeback,
        color: '#2F4F4F',
    },
    [BodyTplFrequentOptionsKey.disbursementsXero]: {
        key: BodyTplFrequentOptionsKey.disbursementsXero,
        displayName: 'Disbursements xero',
        content: disbursementsXero,
        color: '#3357FF',
    },
    [BodyTplFrequentOptionsKey.disbursements]: {
        key: BodyTplFrequentOptionsKey.disbursements,
        displayName: 'Disbursements',
        content: disbursements,
        color: '#800000',
    },
    [BodyTplFrequentOptionsKey.chargeback]: {
        key: BodyTplFrequentOptionsKey.chargeback,
        displayName: 'Chargeback',
        content: chargeback,
        color: '#1E1E1E',
    },
    [BodyTplFrequentOptionsKey.monthly]: {
        key: BodyTplFrequentOptionsKey.monthly,
        displayName: 'Monthly',
        content: monthly,
        color: '#4B0082',
    },
    [BodyTplFrequentOptionsKey.xero]: {
        key: BodyTplFrequentOptionsKey.xero,
        displayName: 'Xero',
        content: xero,
        color: '#FF9933',
    },
    [BodyTplFrequentOptionsKey.leaseMonthly]: {
        key: BodyTplFrequentOptionsKey.leaseMonthly,
        displayName: 'Lease monthly',
        content: leaseMonthly,
        color: '#923ae5',
    },
    [BodyTplFrequentOptionsKey.leaseDisbursements]: {
        key: BodyTplFrequentOptionsKey.leaseDisbursements,
        displayName: 'Lease disbursements',
        content: leaseDisbursements,
        color: '#0035ff',
    },
    [BodyTplFrequentOptionsKey.leaseDisbursementsXero]: {
        key: BodyTplFrequentOptionsKey.leaseDisbursementsXero,
        displayName: 'Lease disbursements xero',
        content: leaseDisbursementsXero,
        color: '#1eef59',
    },
};
